import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import ReactSelect from "../../UI/ReactSelect";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Preview from "../components/Preview.js";
// import { dateConvert } from "../../../../helpers/dateConvert";
import InputAdornment from "@material-ui/core/InputAdornment";
import { BiCopy } from "react-icons/bi";
import * as Yup from "yup";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function Edit(props) {
  const {
    onHide,
    show,
    campaign,
    onCampaigns,
    skip,
    take,
    sortField,
    orderBy,
    partners,
    campaignCategories,
    orders,

    setOrders,

    specialOrders


  } = props;
  const {
    id,
    partnerId,
    discountPercent,
    link,
    // endDiscountPercent,
    expireDate,
    startDate,
    filePath,
    campaignCategoryId,
    nameAz,
    nameRu,
    nameEn,
    descriptionAz,
    descriptionEn,
    descriptionRu,
    specialOffer,
    order,
    specialOrder,
    isActive

  } = campaign;

  const fileUrl = "https://cdn.deyerlisen.az/" + filePath;
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState(true);
  const [imageSrc, setImageSrc] = useState(fileUrl);


  const [ordersOptions, setOrdersOptions] = useState([]);

  const [ordersOption, setOrdersOption] = React.useState(null);



  const [specialOrdersOptions, setSpecialOrdersOptions] = useState([]);

  const [specialOrdersOption, setSpecialOrdersOption] = React.useState(null);




  useEffect(() => {
    setImageSrc(fileUrl);
  }, [fileUrl]);

  const [isError, setIsError] = useState("");

  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };





  useEffect(() => {
    setOrdersOptions(
      orders.map((suggestion) => ({
        value: suggestion,
        label: suggestion,
      }))
    );
  }, [orders]);



  useEffect(() => {
    setSpecialOrdersOptions(
      specialOrders.map((suggestion) => ({
        value: suggestion,
        label: suggestion,
      }))
    );
  }, [specialOrders]);




  const [partnersOptions, setPartnersOptions] = useState([]);
  const [campaignCategoriesOptions, setCampaignCategoriesOptions] = useState(
    []
  );

  const [partnersOption, setPartnersOption] = React.useState(null);
  const [
    campaignCategoriesOption,
    setCampaignCategoriesOption,
  ] = React.useState(null);

  function handleChangePartner(value, setFieldValue) {
    setPartnersOption((prevState) => value);
    setFieldValue("partnerId", value.value);
  }

  function handleChangeCampaignCategory(value, setFieldValue) {
    setCampaignCategoriesOption((prevState) => value);
    setFieldValue("campaignCategoryId", value.value);



    axios
      .get(`${process.env.REACT_APP_API_URL}campaign/campaignOrdersNew?categoryId=${value.value}`)
      // .then((res) => {
      //   const displayStructuresNames = res.data.data.map(({ id, name, desc }) => ({
      //     value: id,
      //     label: `${name} - ${desc}`
      //   }));
      //   setDisplayStructuresNames(displayStructuresNames);
      // });
      .then(({ data: { data } }) => {
        setOrders(data);
      });
    // setChooseDisplayStructuresNames("")
  }

  function handleChangeOrder(value, setFieldValue) {
    setOrdersOption((prevState) => value);
    setFieldValue("order", value.value);


  }


  function handleChangeSpecialOrder(value, setFieldValue) {
    setSpecialOrdersOption((prevState) => value);
    setFieldValue("specialOrder", value.value);


  }


  useEffect(() => {
    setPartnersOptions(
      partners.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.name,
      }))
    );
  }, [partners]);

  useEffect(() => {
    setCampaignCategoriesOptions(
      campaignCategories.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.nameAz,
      }))
    );
  }, [campaignCategories]);


  useEffect(() => {
    setOrdersOptions(
      orders.map((suggestion, index) => ({
        value: suggestion.order,
        label: `${index + 1}.  ${suggestion.partnerName} - ${suggestion.campaignName}`
      }))
    );
  }, [orders]);



  useEffect(() => {
    setSpecialOrdersOptions(
      specialOrders.map((suggestion, index) => ({
        value: suggestion.order,
        label: `${index + 1}.  ${suggestion.partnerName} - ${suggestion.campaignName}`
      }))
    );
  }, [specialOrders]);




  useEffect(() => {
    setPartnersOption((prev) =>
      partnersOptions.find((option) => option.value === partnerId)
    );
  }, [partnerId, partnersOptions]);

  useEffect(() => {
    setCampaignCategoriesOption((prev) =>
      campaignCategoriesOptions.find(
        (option) => option.value === campaignCategoryId
      )
    );
  }, [campaignCategoryId, campaignCategoriesOptions]);



  useEffect(() => {
    setOrdersOption((prev) =>
      // ordersOptions.find((option) => option === order)
      ordersOptions?.find((option) => (option?.value == order))

    );
  }, [order, ordersOptions]);


  useEffect(() => {
    setSpecialOrdersOption((prev) =>
      // ordersOptions.find((option) => option === order)
      specialOrdersOptions?.find((option) => (option?.value == specialOrder))

    );
  }, [specialOrder, specialOrdersOptions]);



  // useEffect(() => {
  //   if (!show) {
  //     setPartnersOption(null);
  //   }
  // }, [show]);

  useEffect(() => {
    if (!show) {
      setCampaignCategoriesOption(null);
      setPartnersOption(null);

      setOrdersOption(null);

    }
  }, [show]);

  const form = useRef(null);


  const handleCopyName = (name, values, setFieldValue) => {
    const nameAz = values.nameAz;
    setFieldValue(name, nameAz);
  };

  const handleCopyDescription = (description, values, setFieldValue) => {
    const descriptionAz = values.descriptionAz;
    setFieldValue(description, descriptionAz);
  };



  const onPutCampaign = (values, resetForm, setSubmitting) => {
    const campaign = new FormData(form.current);
    campaign.append("partnerId", values.partnerId);
    campaign.append("campaignCategoryId", values.campaignCategoryId);
    campaign.append("specialOffer", values.specialOffer);
    campaign.append("order", values.order);
    campaign.append("specialOrder", values.specialOrder);



    axios
      .put(`${process.env.REACT_APP_API_URL}campaign`, campaign, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onCampaigns(skip, take, sortField, orderBy);
        setPreview(true);
        setImageSrc("");
        setFile("");
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };


  const EditSchema = Yup.object().shape({
    partnerId: Yup.string().required("Partner is required"),
    discountPercent: Yup.string().required("Discount percent is required"),
    // link: Yup.string().required("Link is required"),
    // endDiscountPercent: Yup.string().required("End Discount percent is required"),
    expireDate: Yup.string().required("Expire date is required"),
    startDate: Yup.string().required("Start date is required"),
    campaignCategoryId: Yup.string().required("Campaign category is required"),
    nameAz: Yup.string().required("Name is required"),
    descriptionAz: Yup.string().required("Description is required"),
    nameEn: Yup.string().required("Name is required"),
    descriptionEn: Yup.string().required("Description is required"),
    nameRu: Yup.string().required("Name is required"),
    descriptionRu: Yup.string().required("Description is required"),
  });

  const getInputClasses = (touched, errors, fieldName) => {
    if (touched[fieldName] && errors[fieldName]) {
      return true;
    }
    if (touched[fieldName] && errors[fieldName]) {
      return false;
    }

    return false;
  };


  useEffect(() => { }, [partnersOption, partnerId]);

  useEffect(() => { }, [campaignCategoriesOption, campaignCategoryId]);


  // useEffect(() => { }, [order]);
  useEffect(() => { }, [ordersOptions, order]);
  useEffect(() => { }, [specialOrdersOptions, specialOrder]);


  return (
    <Modal
      onHide={onHide}
      show={show}
      size="md"
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {campaign &&
        Object.keys(campaign).length !== 0 &&
        campaign.constructor === Object && (
          <Formik
            initialValues={{
              id: id,
              partnerId: partnerId,
              discountPercent: discountPercent,
              link: link,
              // endDiscountPercent: endDiscountPercent,
              expireDate: expireDate,
              file: file,
              startDate: startDate,
              campaignCategoryId: campaignCategoryId,
              nameAz: nameAz,
              nameEn: nameEn,
              nameRu: nameRu,
              descriptionAz: descriptionAz,
              descriptionEn: descriptionEn,
              descriptionRu: descriptionRu,
              specialOffer: specialOffer,
              order: order,
              specialOrder: specialOrder,

            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutCampaign(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit} ref={form}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {isError && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block MuiFormLabel-root Mui-error">
                                {isError}
                              </div>
                            </div>
                          )}
                          <input
                            type="hidden"
                            id="id"
                            name="id"
                            value={values.id}
                          />
                          <ReactSelect
                            suggestions={partnersOptions}
                            handleChangeSingle={(value) =>
                              handleChangePartner(value, setFieldValue)
                            }
                            single={partnersOption}
                            label="Partner Id"
                            placeholder="Partner Id"
                            inputId="partnerId"
                            error={getInputClasses(touched, errors, "partnerId")}
                          />
                        </div>
                        {touched.partnerId && errors.partnerId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.partnerId}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="nameAz"
                            name="nameAz"
                            label="Name Az"
                            placeholder="Name Az"
                            className="w-100"
                            value={values.nameAz}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "nameAz")}
                          />
                        </div>
                        {touched.nameAz && errors.nameAz ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.nameAz}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="nameEn"
                            name="nameEn"
                            label="Name En"
                            placeholder="Name En"
                            className="w-100"
                            value={values.nameEn}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "nameEn")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyName("nameEn", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.nameEn && errors.nameEn ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.nameEn}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="nameRu"
                            name="nameRu"
                            label="Name Ru"
                            placeholder="Name Ru"
                            className="w-100"
                            value={values.nameRu}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "nameRu")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyName("nameRu", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.nameRu && errors.nameRu ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.nameRu}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="descriptionAz"
                            name="descriptionAz"
                            label="Description Az"
                            placeholder="Description Az"
                            className="w-100"
                            value={values.descriptionAz}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            variant="outlined"
                            multiline
                            rowsMax="4"
                            margin="normal"
                            error={getInputClasses(touched, errors, "descriptionAz")}

                          />
                        </div>
                        {touched.descriptionAz && errors.descriptionAz ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.descriptionAz}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="descriptionEn"
                            name="descriptionEn"
                            label="Description En"
                            placeholder="Description En"
                            className="w-100"
                            value={values.descriptionEn}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "descriptionEn")}
                            variant="outlined"
                            multiline
                            rowsMax="4"
                            margin="normal"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyDescription("descriptionEn", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}

                          />
                        </div>
                        {touched.descriptionEn && errors.descriptionEn ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.descriptionEn}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="descriptionRu"
                            name="descriptionRu"
                            label="Description Ru"
                            placeholder="Description Ru"
                            className="w-100"
                            value={values.descriptionRu}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "descriptionRu")}
                            variant="outlined"
                            multiline
                            rowsMax="4"
                            margin="normal"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyDescription("descriptionRu", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.descriptionRu && errors.descriptionRu ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.descriptionRu}
                            </div>
                          </div>
                        ) : null}
                      </div>


                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="link"
                            name="link"
                            label="Link"
                            placeholder="Link"
                            className="w-100"
                            value={values.link}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "link")}
                          />
                        </div>
                        {/* {touched.link && errors.link ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.link}
                            </div>
                          </div>
                        ) : null} */}
                      </div>


                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="discountPercent"
                            name="discountPercent"
                            label="Discount percent"
                            placeholder="Discount percent"
                            className="w-100"
                            value={values.discountPercent}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "discountPercent")}
                          />
                        </div>
                        {touched.discountPercent && errors.discountPercent ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.discountPercent}
                            </div>
                          </div>
                        ) : null}
                      </div>


                      <div className="col-12 col-md-12 col-lg-12 mt-3">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">



                          <FormControlLabel
                            control={
                              <Checkbox
                                id="specialOffer"
                                name="specialOffer"
                                value={values.specialOffer}
                                onChange={handleChange}
                                checked={values.specialOffer ? true : false}
                              />
                            }
                            label="Special Offer"
                          // defaultValue={"1"}
                          />

                        </div>
                        {/* {formik.touched.saleOption && formik.errors.saleOption ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.saleOption}
                            </div>
                          </div>
                        ) : null} */}

                      </div>


                      {
                        values.specialOffer &&

                        <div className="col-12 col-md-12 col-lg-12">
                          <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                            <ReactSelect
                              suggestions={specialOrdersOptions}
                              handleChangeSingle={(value) =>
                                handleChangeSpecialOrder(value, setFieldValue)
                              }
                              single={specialOrdersOption}
                              label="Special Order Id"
                              placeholder="Special Order Id"
                              inputId="specialOrder"
                              error={getInputClasses(touched, errors, "specialOrder")}
                            />
                          </div>

                          {touched.specialOrder && errors.specialOrder ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.specialOrder}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      }






                      {/* <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="endDiscountPercent"
                            name="endDiscountPercent"
                            label="End discount percent"
                            placeholder="End discount percent"
                            className="w-100"
                            value={values.endDiscountPercent}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "endDiscountPercent")}
                          />
                        </div>
                        {touched.endDiscountPercent && errors.endDiscountPercent ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.endDiscountPercent}
                          </div>
                        </div>
                      ) : null}
                      </div> */}
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="startDate"
                            name="startDate"
                            label="Start date"
                            placeholder="Start date"
                            type="datetime-local"
                            className="w-100"
                            // value={dateConvert(values.startDate)}
                            value={values.startDate ? values.startDate : ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "startDate")}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                        {touched.startDate && errors.startDate ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.startDate}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="expireDate"
                            name="expireDate"
                            label="Expire date"
                            type="datetime-local"
                            placeholder="Expire date"
                            className="w-100"
                            value={values.expireDate ? values.expireDate : ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "expireDate")}
                          />
                        </div>
                        {touched.expireDate && errors.expireDate ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.expireDate}
                            </div>
                          </div>
                        ) : null}
                      </div>

                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <ReactSelect
                            suggestions={campaignCategoriesOptions}
                            handleChangeSingle={(value) =>
                              handleChangeCampaignCategory(value, setFieldValue)
                            }
                            single={campaignCategoriesOption}
                            label="Campaign Category Id"
                            placeholder="Campaign Category Id"
                            inputId="campaignCategoryId"
                            error={getInputClasses(touched, errors, "campaignCategoryId")}
                          />
                        </div>
                        {touched.campaignCategoryId && errors.campaignCategoryId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.campaignCategoryId}
                            </div>
                          </div>
                        ) : null}
                      </div>


                      {
                        isActive &&
                        <div className="col-12 col-md-12 col-lg-12">
                          <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                            <ReactSelect
                              suggestions={ordersOptions}
                              handleChangeSingle={(value) =>
                                handleChangeOrder(value, setFieldValue)
                              }
                              single={ordersOption}
                              label="Order Id"
                              placeholder="Order Id"
                              inputId="order"
                              error={getInputClasses(touched, errors, "order")}
                            />
                          </div>

                          {touched.order && errors.order ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.order}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      }



                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3">
                          <label htmlFor="contained-button-file">
                            <Input
                              accept="image/*"
                              id="contained-button-file"
                              type="file"
                              name="file"
                              label="File {Path}"
                              placeholder="File Path"
                              className="w-100"
                              onChange={imagePreview}
                              value={file}
                              hidden
                            />
                            <Button2 variant="contained" component="span">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Devices/Camera.svg"
                                )}
                                className="mr-2"
                              />
                              Change image
                            </Button2>
                          </label>
                          <Preview
                            preview={preview}
                            imageSrc={imageSrc}
                            onClick={onClick}
                            onError={(e) => { e.target.onerror = null; e.target.src = "/media/error/default.png" }}
                          />
                        </div>
                        {touched.file && errors.file ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.file}
                            </div>
                          </div>
                        ) : null}
                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Edit</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
